import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { PageShell } from "@/ui/PageShell";
import { withBase } from "@/ui/Header";
import { usePageScale } from "@/ui/usePageScale";
import { COLOR } from "@/ui/tokens";

const BASE = { W: 1264, MARGIN_X: 108 } as const;
function useScale() {
    const { s, px, sfpx } = usePageScale({ baseW: BASE.W, max: 1.2 });
    return { s, spx: px, sfpx };
}

export default function NeedLoginPage() {
    const { s, spx, sfpx } = useScale();
    const nav = useNavigate();
    const location = useLocation();
    const featureName = (location.state as any)?.featureName || "";

    return (
        <PageShell
            title=""
            onBack={() => nav(-1)}
            backIcon={withBase("icons/prev1.svg")}
            width={spx(BASE.W)}
            bodyStyle={{ paddingLeft: spx(BASE.MARGIN_X), paddingRight: spx(BASE.MARGIN_X) }}
        >
            <div style={{ height: spx(220) }} />
            <div style={{ textAlign: "center", fontSize: sfpx(42), fontWeight: 900, color: COLOR.text }}>
                {featureName ? `${featureName} 기능을 사용하려면` : "로그인이 필요합니다."}
            </div>
            {featureName && (
                <div style={{ textAlign: "center", fontSize: sfpx(42), fontWeight: 900, color: "#111", marginTop: spx(8) }}>
                    로그인 후 이용해 주세요.
                </div>
            )}

            <div style={{ height: spx(40) }} />
            <div style={{ display: "grid", placeItems: "center" }}>
                <button
                    type="button"
                    onClick={() => nav("/auth/login", { replace: true })}
                    style={{
                        width: spx(724),
                        height: spx(124),
                        borderRadius: s(12),
                        border: "none",
                        background: COLOR.black,
                        color: COLOR.white,
                        fontSize: sfpx(40),
                        fontWeight: 900,
                    }}
                >
                    확인
                </button>
            </div>
        </PageShell>
    );
}
